import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  public current(params?: any) {
    const url = "/api/v4/users/current";
    return this.http.get(url, { params }).pipe(map((data: any) => data.user));
  }

  public properties() {
    const url = "/api/v4/user-properties";
    return this.http.get(url);
  }
}
